import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { Button } from "react-bulma-components";
import { iAmNotReady } from "socket/events/iAmNotReady";
import { iAmReady } from "socket/events/iAmReady";
import { store } from "store/store";
import styles from "./styles.module.scss";
import { useT } from "i18n/I18nProvider";

export const ReadyButton = observer(() => {
  const t = useT();
  const readyButton = (
    <Button
      size="medium"
      color="primary"
      onClick={() => {
        iAmReady();
      }}
    >
      {t("ready.ready")}
    </Button>
  );
  const notReadyButton = (
    <Button
      size="medium"
      color="warning"
      onClick={() => {
        iAmNotReady();
      }}
    >
      {t("ready.notReady")}
    </Button>
  );
  return (
    <div
      className={classNames(styles.button, {
        [styles.flip]: store.iAmReady,
        [styles.disabled]: !store.iAmReady && !store.iAmActiveUser,
      })}
    >
      <div className={styles.ready}>{readyButton}</div>
      <div className={styles.notReady}>{notReadyButton}</div>
    </div>
  );
});
